<template>
  <div class="row">
    <base-radio-button
      v-for="(option, index) in options"
      :id="name + '-' + index"
      :key="name + '-' + index"
      :model-value="modelValue"
      :option="option"
      :name="name"
      :data-test-base-radio-buttons-stacked="name"
      @update:modelValue="(e) => $emit('update:modelValue', modelValue)"
    />
  </div>
</template>
<script>
import BaseRadioButton from './BaseRadioButton.vue';

export default {
  name: 'BaseRadioButtonsSideBySide',
  emits:['update:modelValue'],
  components: { BaseRadioButton },
  props: {
    name: {
      type: String,
      default() {
        return 'default-radio-button-name';
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    modelValue: {
      type: [Boolean, Number, String],
      default() {
        return null;
      }
    }
  }
};
</script>
